var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImg32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 0H2a2 2 0 0 0-2 2v36c0 1.1.9 2 2 2h36a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z",
    fill: "#C3D0DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 16.5 4.1 33.8l-.1.5V36c0 .6.4 1 1 1h30c.6 0 1-.4 1-1v-1.6c0-.3 0-.5-.3-.7l-4.5-5a1 1 0 0 0-1.4 0l-3.9 3.5a1 1 0 0 1-1.5-.3l-9-15.4a1 1 0 0 0-1.8 0Z",
    fill: "#039BE5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    r: 4,
    fill: "#039BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImg32);
export default ForwardRef;